




















require("axios");
import { Component, Prop, Vue } from "vue-property-decorator";
import NewApi, { BasePath } from "../ts/api";
import { DefaultApi, Image, Credentials } from "../api";
import GalleryManager from "./GalleryManager.vue";
import ImageManager from "./ImageManager.vue";
import AwardManager from "./AwardManager.vue";
import VueTinyTabs from 'vue-tiny-tabs'

let api: DefaultApi;

@Component({
  components: {
    GalleryManager,
    ImageManager,
    AwardManager,
    VueTinyTabs,
  }
})
export default class Dashboard extends Vue {
  credentials = {} as Credentials;
  imgs = [] as Image[];
  gallery = false;


  mounted() {
    api = NewApi();

    this.getImages();
  }

  login() {
    api
      .loginPost(this.credentials)
      .then(function(r) {
        console.log("login ok");
      })
      .catch(e => console.error("could not login"));
  }

  getImages() {
    var resp = api.imageGet();
    resp
      .then(i => (this.imgs = i.data))
      .catch(e => console.log("fail to fetch images"));
  }

  getImageUrl(filename: string) {
    return BasePath() + "/files/" + filename;
  }

  postImage(files: File[]) {
    api
      .imagePost(files)
      .then(r => this.getImages())
      .catch(e => console.log("could not upload images"));
  }
}
